import React, { useEffect } from 'react';
import PropType from 'prop-types';

// Components
import MetaDescription from '../../components/Molecules/MetaDescription';

// Layouts
import Section from '../../components/Molecules/Section/Section';
import { Heading } from '../../components/Atoms/Heading';

import TableListing from '../../components/modules/Yamb/Molecules/TableListing/TableListing';

const texts = {
	single: 'Alone',
	multi: 'With a friend',
	arena: 'Arena game',
};

function YambSetup({ location }) {
	const [, mode = ''] = location.search.split('?mode=');

	useEffect(() => {
		sessionStorage.clear();
	}, []);

	return (
		<>
			<MetaDescription
				page={{
					meta: {
						pageTitle: 'Choose game type - Yamb - The game',
						metaDescription: 'Online multiplayer Yamb (Yahtzee) game',
					},
				}}
			/>
			<Section>
				<Heading textAlign="center" fontWeight="normal" padding="bm txl">
					Choose game mode to start playing -
					{' '}
					{texts[mode]}
				</Heading>
				<TableListing playMode={mode} />
			</Section>
		</>
	);
}

YambSetup.propTypes = {
	location: PropType.shape({
		search: PropType.string,
	}).isRequired,
};

export default YambSetup;
